<template>
    <div>
        <div class="modal c-modal fade in"  ref="modal" id="myModal" tabindex="-1"
             @click="$emit('close')"
             @keydown.esc="$emit('close')" >
            <div class="modal-dialog" @click.stop>
                <div class="modal-content">

                    <div class="modal-body">
                        <button type="button" class="close" @click="$emit('close')"><span aria-hidden="true">×</span></button>
                        <!--{{eventId}}-->
                        <div class="c-modal__wrap row">
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text0')"
                                        v-bind:dataProperty="'volajici'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text1')"
                                        v-bind:dataProperty="'telefon'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text2')"
                                        v-bind:dataProperty="'datum'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{disabled: 'disabled'}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text3')"
                                        v-bind:dataProperty="'casVzniku'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{disabled: 'disabled'}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text4')"
                                        v-bind:dataProperty="'cisloVyzvy'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{disabled: 'disabled'}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>

                            <hr class="col-xs-12">

                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text5')"
                                        v-bind:dataProperty="'obec'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:suggestion="'place'"
                                        v-bind:labelName="translate('eventEditModal.text6')"
                                        v-bind:dataProperty="'ulice'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:fillValue="suggestPlace"
                                        @suggestLat="suggestLat"
                                        @suggestLon="suggestLon"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text7')"
                                        v-bind:dataProperty="'cp'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text8')"
                                        v-bind:dataProperty="'co'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text9')"
                                        v-bind:dataProperty="'poi'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text10')"
                                        v-bind:dataProperty="'gpsLat'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:fillValue="suggestLatValue"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text11')"
                                        v-bind:dataProperty="'gpsLong'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:fillValue="suggestLonValue"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 ">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text12')"
                                        v-bind:dataProperty="'adresaPoznamka'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>

                            <hr class="col-xs-12">


                            <div class="col-xs-12 col-md-6">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text13')"
                                        v-bind:dataProperty="'klasifikace'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text14')"
                                        v-bind:dataProperty="'klasifikacePoznamka'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-4">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text15')"
                                        v-bind:dataProperty="'nalehavost'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{max: 4, min: 1}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12"></div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text16')"
                                        v-bind:dataProperty="'vskRZP'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text17')"
                                        v-bind:dataProperty="'vskUM'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text18')"
                                        v-bind:dataProperty="'vskRV'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text19')"
                                        v-bind:dataProperty="'vskLZS'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text20')"
                                        v-bind:dataProperty="'vskKOR'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-6 col-md-4 col-lg-2">
                                <formInput
                                        v-bind:inputType="'number'"
                                        v-bind:labelName="translate('eventEditModal.text21')"
                                        v-bind:dataProperty="'vskIP'"
                                        v-bind:dataEntityId="eventId"
                                        v-bind:dataAttr="{min: 0}"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>

                            <hr class="col-xs-12">
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput v-bind="{
                                    inputType: 'text',
                                    labelName: translate('eventEditModal.text22'),
                                    dataProperty: 'pacientJmeno',
                                    dataEntityId: eventId }"
                                    @valueChange="valueChange">
                                </formInput>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput v-bind="{
                                    inputType: 'text',
                                    labelName: translate('eventEditModal.text23'),
                                    dataProperty: 'rokNarozeni',
                                    dataEntityId: eventId }"
                                    @valueChange="valueChange">
                                </formInput>
                            </div>
                            <hr class="col-xs-12">

                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput v-bind="{
                                    inputType: 'select',
                                    labelName: translate('eventEditModal.text25'),
                                    dataProperty: 'nemocnice',
                                    dataEntityId: eventId }"
                                           @valueChange="valueChange">
                                </formInput>
                            </div>

                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput v-bind="{
                                    inputType: 'select',
                                    labelName: translate('eventEditModal.ward'),
                                    dataProperty: 'oddeleni',
                                    dataEntityId: eventId }"
                                           @valueChange="valueChange">
                                </formInput>
                            </div>

                            <div class="col-xs-12 col-md-6 col-lg-3">
                                <formInput v-bind="{
                                    inputType: 'select',
                                    labelName: translate('eventEditModal.text24'),
                                    dataProperty: 'stavUkonceni',
                                    dataEntityId: eventId }"
                                           @valueChange="valueChange">
                                </formInput>
                            </div>

                            <hr class="col-xs-12">

                            <div class="col-xs-12">
                                <formInput
                                        v-bind:inputType="'text'"
                                        v-bind:labelName="translate('eventEditModal.text26')"
                                        v-bind:dataProperty="'poznamka'"
                                        v-bind:dataEntityId="eventId"
                                        @valueChange="valueChange">
                                </formInput>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import formInput from '@/components/form/formInput.vue';
    import {mapActions} from "vuex";
    import getPropertyValue from '@/mixins/getPropertyValue.js';
    import getPlaceFromNominatim from '@/mixins/getPlaceFromNominatim.js';

    export default {
        name: "eventEditModal",
        components: {
            formInput
        },
        data: function () {
            return {
                entityData: null,
                suggestLatValue: null,
                suggestLonValue: null,
                suggestPlace: null,
                gpsLat: null,
                gpsLon: null
            }
        },
        methods: {
            getPlaceFromNominatim,
            suggestLat(value){
                this.suggestLatValue = value;
            },
            suggestLon(value){
                this.suggestLonValue = value;
            },
            getEntity(entityId) {
                return this.$store.getters.getEntity(entityId);
            },
            focusModal() {
                this.$refs.modal.focus();
            },
            handleGps(payload){
                if(payload.property == "gpsLat"){
                    this.gpsLat = parseFloat(payload.value);
                }

                if(payload.property == "gpsLong"){
                    this.gpsLon = parseFloat(payload.value);
                }

                if(this.gpsLat && this.gpsLon){
                    this.suggestPlaceByGps();
                }
            },
            suggestPlaceByGps() {
                let url = `${process.env.VUE_APP_NOMINATIM_SERVER || 'https://zzs.fel.cvut.cz/nominatim'}/reverse/?lat=${this.gpsLat}&lon=${this.gpsLon}&format=json&addressdetails=1&zoom=17`;
                fetch(url).then(response => {
                    if (!response.ok) {
                        return
                    }

                    response.json().then(json => {
                        this.suggestPlace = this.getPlaceFromNominatim(json);
                    })
                })
            },
            handleBothGpsCoordinatesInSingleValue(payload, property){
                if(payload.property === property && (typeof payload.value === 'string' || payload.value instanceof String)) {
                    console.log("Zde zacina vypis");
                    console.log(payload);
                    console.log(payload.value);

                    const pieces = [...(payload.value).matchAll(/^(-?\d+(\.\d+)?)\D+(-?\d+(\.\d+)?)$/g)];
                    const piece = pieces.length == 1 ? pieces[0].filter(function(element) {
                                        return element !== undefined;
                                    }) : false;
                    
                    if(piece && piece.length == 5){
                        return [piece[1], piece[3]];
                    }
                }

                return false;
            },
            async valueChange({payload, promise, invokedByEmittedEvent}) {
                /*payload.value = this.translate('Page1.' + payload.value);
                console.log(payload.value)*/
                try {
                    
                    /**
                     * Check, if GPS coordinate contains both values
                     */
                    let fillLon = this.handleBothGpsCoordinatesInSingleValue(payload, "gpsLat");
                    let fillLat = this.handleBothGpsCoordinatesInSingleValue(payload, "gpsLong");
                    if(fillLon){
                        payload.value = fillLon[0];
                    }
                    if(fillLat){
                        payload.value = fillLat[1];
                    }

                    /**
                     * Send payload
                     */
                    if (this.isEditorMode) {
                        await this.sendCommand({cmd: 'editEventScenario', payload});
                    } else {
                        await this.sendCommand({cmd: 'editEvent', payload});
                    }
                    await promise.resolve();
                    
                    /**
                     * Fill (suggest) second missing GPS coordinate
                     */
                    if(fillLon){
                        this.suggestLonValue = fillLon[1];
                        this.gpsLon = fillLon[1];
                    }
                    if(fillLat){
                        this.suggestLatValue = fillLat[0];
                        this.gpsLat = fillLat[0];
                    }

                    /**
                     * If we know both GPS coordinates, geocode address by GPS
                     */
                    if(invokedByEmittedEvent !== true){
                        this.handleGps(payload);
                    }
                } catch (e) {
                    promise.reject(e);
                }
            },
            getPropertyValue,
            ...mapActions(['sendCommand']),
        },
        props: {
            eventId: Number
        },
        computed:{
            getWaitingEvents () {
                return null;

            },

            isEditorMode() {
                return this.$store.state.editMode;
            },
        },
        created() {
            this.entityData = this.getEntity(this.eventId);
            
            if(this.entityData){
                this.gpsLat = parseFloat(getPropertyValue(this.entityData, 'gpsLat'));
                this.gpsLon = parseFloat(getPropertyValue(this.entityData, 'gpsLong'));
            }
        },
        mounted() { // lifecycle hook kdy je vytvořeno už html
            this.focusModal(); // aby fungoval ESC na zavření
        }
    }
</script>

<style scoped>

</style>
